const stripHtml = (html: string): string =>
  new DOMParser().parseFromString(html, 'text/html').body.textContent ?? '';

export const copyTextToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);

    return true;
  } catch {
    return false;
  }
};

export const copyHtmlToClipboard = async (html: string): Promise<boolean> => {
  const plain = stripHtml(html);

  try {
    const item = new ClipboardItem({
      'text/html': new Blob([html], { type: 'text/html' }),
      'text/plain': new Blob([plain], { type: 'text/plain' }),
    });

    await navigator.clipboard.write([item]);

    return true;
  } catch {
    return copyTextToClipboard(plain);
  }
};
